import { FC, useContext, useEffect } from "react";

import { PUBSUB_VIRTUAL_CLASS_STATE_MESSAGE_TYPE } from "../../shared/types/av-state";

import { CourseInfo } from "./CourseInfo";
import { CourseStats } from "./CourseStats";
import { UserStats } from "./UserStats";

import { serverGetMonitoringStats } from "api/api-monitoring";
import { WebsocketContext } from "providers/WebsocketProvider";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectCurrentCourseId } from "store/selectors";
import { selectClassStateLastUpdatedAt } from "store/selectors/pubsub-virtual-class-state";
import { monitoringStateActions } from "store/slices/monitoring";

export const CourseMonitoringDashboard: FC = () => {
  const dispatch = useAppDispatch();
  const courseId = useAppSelector(selectCurrentCourseId);

  const { sendWebsocketMessage, websocketStatus } = useContext(WebsocketContext);

  const hasReceivedClassState = useAppSelector(selectClassStateLastUpdatedAt) !== null;

  useEffect(() => {
    if (hasReceivedClassState || websocketStatus !== "connected") return;
    //  Request the current state for monitoring
    sendWebsocketMessage({
      type: PUBSUB_VIRTUAL_CLASS_STATE_MESSAGE_TYPE,
      action: "join",
      force: false,
      virtual_user_id: `monitoring`,
    });
  }, [hasReceivedClassState, sendWebsocketMessage, websocketStatus]);

  useEffect(() => {
    if (!courseId) return;
    const fetchMonitoringStats = async () => {
      const stats = await serverGetMonitoringStats(courseId);
      dispatch(monitoringStateActions.setMonitoringStats(stats));
    };
    fetchMonitoringStats();
  }, [courseId, dispatch]);

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <div className="w-full flex-shrink-0 bg-blue p-4">
        <h1 className="text-center text-white">ForumV Monitoring Dashboard</h1>
      </div>
      <div className="flex-1 overflow-y-auto p-8">
        <div className="flex flex-col gap-8">
          <div>
            <h1 className="h2">Course Info</h1>
            <CourseInfo />
          </div>
          <div>
            <h1 className="h2">Course Stats</h1>
            <CourseStats />
          </div>
          <div>
            <h1 className="h2">User Stats</h1>
            <UserStats />
          </div>
        </div>
      </div>
    </div>
  );
};
